/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { appSyncGraphQLApi } from '../../app/smorgAppSyncGraphQLApi';
import { currentViewWeekStartDateStr } from '../../services/planner';

export interface EndUserPlannerState {
  currentPlannerViewWeekStartDate: string | null;
}

const initialState: EndUserPlannerState = {
  currentPlannerViewWeekStartDate: currentViewWeekStartDateStr(1),
};

export const endUserPlannerSlice = createSlice({
  name: 'endUserPlanner',
  initialState,
  reducers: {
    switchToViewWeek: (state, action: PayloadAction<string>) => {
      state.currentPlannerViewWeekStartDate = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(appSyncGraphQLApi.util.resetApiState, (state) => {
      state.currentPlannerViewWeekStartDate = currentViewWeekStartDateStr(1);
    });
  },
});

export const { switchToViewWeek } = endUserPlannerSlice.actions;

export default endUserPlannerSlice.reducer;
